import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=565b6378&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=565b6378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b6378",
  null
  
)

export default component.exports